import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonsModule } from '@shared/core/components/buttons';

import { CartDirectivesModule } from './directives';
import { CartComponentsModule } from './components';
import { CartTypesModule } from './cartTypes';

import { CartComponent } from './cart.shared.component';

@NgModule({
    declarations: [
        CartComponent,
    ],
    imports: [
        CommonModule,
        ButtonsModule,
        CartDirectivesModule,
        CartComponentsModule,
        CartTypesModule,
    ],
    exports: [
        CartComponent,
        CartComponentsModule,
        CartTypesModule,
        CartDirectivesModule,
    ],
})
export class CartModule {
    public static entry = CartComponent;
}
